import { render, staticRenderFns } from "./laowuList.vue?vue&type=template&id=3a124725&scoped=true&"
import script from "./laowuList.vue?vue&type=script&lang=js&"
export * from "./laowuList.vue?vue&type=script&lang=js&"
import style0 from "./laowuList.vue?vue&type=style&index=0&id=3a124725&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a124725",
  null
  
)

export default component.exports